import { Controller } from "@hotwired/stimulus";
import Chart from 'chart.js/auto';
import { barChart } from "../helpers/chartjs/bar";
import { minmaxChart } from "../helpers/chartjs/minmax";
import { janeeChart } from "../helpers/chartjs/janee";

const chartConfig = {
  'bar': barChart,
  'minmax': minmaxChart,
  'janee': janeeChart,
}
export default class extends Controller {

  connect() {
    const chartJson = this.element.querySelector('script[type="application/json"]');
    if (!chartJson) return;

    const chart = JSON.parse(chartJson.textContent.trim());

    if (!chart || !chart.type || !chartConfig[chart.type]) return;

    const config = chartConfig[chart.type](chart);

    const canvas = document.createElement("canvas");
    this.element.appendChild(canvas);
    const ctx = canvas.getContext("2d");

    if (!ctx || !config) return;

    this.chart = new Chart(ctx, config);
  }

  disconnect() {
    // Clean up chart to prevent leaks
    if (this.chart) this.chart.destroy();
  }
}
